module.exports = "/components/components/comments-ccd356.html";